<div id="main">

  <button id="close" mat-dialog-close>
    <fa-icon [icon]="faTimes"></fa-icon>
  </button>

  <div>
    <h4>{{'JOB_TASK_TITLE_DETAILS'|translate}}</h4>
  </div>

  <app-progressbar *ngIf="isLoading"></app-progressbar>
  <ngb-alert type="warning" class="mt-3" [dismissible]="false"
             *ngIf="jobTask?.status === jobTaskStatus.STATUS_CANCELLED">
    {{"JOB_TASK_CANCEL_AT" | translate}} {{ jobTask?.cancelled_at | date:'medium'}}
  </ngb-alert>
  <ngb-alert type="warning" class="mt-3" [dismissible]="false" *ngIf="jobTask?.status === jobTaskStatus.STATUS_WARNING">
    {{ jobTask?.error.message}}
  </ngb-alert>
  <ngb-alert type="danger" class="mt-3" [dismissible]="false" *ngIf="jobTask?.status === jobTaskStatus.STATUS_FAILED">
    {{ jobTask?.error.message}}
  </ngb-alert>
  <ngb-alert type="info" class="mt-3" [dismissible]="false"
             *ngIf="jobTask?.detail !== null && jobTask?.status === jobTaskStatus.STATUS_IN_PROGRESS">
    <ul>
      <li *ngIf="jobTask?.detail?.current_location !== null">
        {{"JOB_TASK_CURRENT_EXPORT_LOCATION" | translate}}
        <strong>{{jobTask?.detail?.current_location?.name}}</strong>
      </li>
    </ul>
  </ngb-alert>

  <table class="table" *ngIf="!isLoading">
    <tbody>
    <tr *ngIf="jobTask?.status === jobTaskStatus.STATUS_COMPLETED">
      <td>{{"JOB_TASK_DOWNLOAD" | translate}}</td>
      <td>
        <app-button-download-export [object]="jobTask"></app-button-download-export>
        {{  (jobTask?.filesize|fileSize) }}
      </td>
    </tr>
    <tr>
      <td>{{"JOB_TASK_STATUS" | translate}}</td>
      <td>
        <div [ngbTooltip]="jobTask?.status | jobTaskStatus: 'tooltip'" [ngClass]="jobTask?.status | jobTaskStatus"></div>
      </td>
    </tr>

    <tr>
      <td>{{"JOB_TASK_PROJECT" | translate}}</td>
      <td>{{jobTask?.project_id + ' - ' + jobTask?.project_name}} </td>
    </tr>

    <tr>
      <td>{{"JOB_TASK_START_DATE" | translate}}</td>
      <td>{{jobTask?.start_date| date: 'medium'}}</td>
    </tr>

    <tr>
      <td>{{"JOB_TASK_END_DATE" | translate}}</td>
      <td>{{jobTask?.end_date | date: 'medium'}}</td>
    </tr>
    <tr>
      <td>{{"JOB_TASK_DATA_TYPE" | translate}}</td>
      <td>{{jobTask?.type}}</td>
    </tr>
    <tr>
      <td>{{"JOB_TASK_DATE_START_EXPORT" | translate}}</td>
      <td>{{jobTask?.message?.start_date | date: 'medium'}}</td>
    </tr>
    <tr>
      <td>{{"JOB_TASK_DATE_END_EXPORT" | translate}}</td>
      <td>{{jobTask?.message?.end_date | date: 'medium'}}</td>
    </tr>
    <tr>
      <td colspan="2">{{"JOB_TASK_LOCATIONS" | translate }}</td>
    </tr>
    <tr>
      <td colspan="2">
        <mat-chip-list *ngFor="let location of jobTask?.detail?.location;" class="locations">
          <mat-chip
            [ngClass]="{'location' : location.id === jobTask?.detail?.current_location?.id &&
            jobTask.status === jobTaskStatus.STATUS_IN_PROGRESS}"
            ngbTooltip="{{location.id}}">
            {{ location.name }}
          </mat-chip>
        </mat-chip-list>
      </td>
    </tr>
    <tr>
      <td>{{"JOB_TASK_HAVE_OFFSET" | translate}}</td>
      <td>{{(jobTask?.message?.show_offset ? "YES" : "NO") | translate}}</td>
    </tr>
    </tbody>
  </table>

</div>
